import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { ActorContextRow, truncateId } from "./ActorContextRow";

export const PlayerActorContextTypename = "PlayerActorContext" as const;

export const PlayerActorContextFragment = graphql(`
  fragment PlayerActorContextFields on PlayerActorContext {
    __typename
    playerProfileId
    accountId
  }
`);

interface Props {
  data: FragmentOf<typeof PlayerActorContextFragment>;
}

export function PlayerActorContext({ data }: Props) {
  const p = readFragment(PlayerActorContextFragment, data);
  return (
    <ActorContextRow>
      player {truncateId(p.playerProfileId)} (account{" "}
      {truncateId(p.accountId)})
    </ActorContextRow>
  );
}
